/**
 * Format Slovak/Czech phone number to international format +421/+420
 * @param {string} phone - Phone number to format
 * @returns {string} - Formatted phone number
 */
export const formatSlovakPhone = (phone) => {
  if (!phone) return '';
  
  let cleaned = phone.replace(/[^\d+]/g, '');
  let countryCode = '';
  
  if (cleaned.startsWith('+421') || cleaned.startsWith('00421') || cleaned.startsWith('421')) {
    countryCode = '+421';
    cleaned = cleaned.replace(/^(\+421|00421|421)/, '');
  } else if (cleaned.startsWith('+420') || cleaned.startsWith('00420') || cleaned.startsWith('420')) {
    countryCode = '+420';
    cleaned = cleaned.replace(/^(\+420|00420|420)/, '');
  }
  
  if (cleaned.startsWith('0')) {
    countryCode = countryCode || '+421';
    cleaned = cleaned.substring(1);
  }
  
  if (cleaned.length === 9) {
    if (countryCode === '+420') {
      return `${countryCode} ${cleaned.substring(0, 3)} ${cleaned.substring(3, 6)} ${cleaned.substring(6, 9)}`;
    }
    
    if (cleaned.startsWith('9')) {
      return `${countryCode || '+421'} ${cleaned.substring(0, 3)} ${cleaned.substring(3, 6)} ${cleaned.substring(6, 9)}`;
    }

    if (cleaned.startsWith('2')) {
      return `${countryCode || '+421'} ${cleaned.substring(0, 1)} ${cleaned.substring(1, 5)} ${cleaned.substring(5, 9)}`;
    }
    
    return `${countryCode || '+421'} ${cleaned.substring(0, 2)} ${cleaned.substring(2, 5)} ${cleaned.substring(5, 9)}`;
  }
  
  return `${countryCode || '+421'} ${cleaned}`;
};

/**
 * Format phone number on input (allows partial input during typing)
 * @param {string} phone - Current input value
 * @returns {string} - Formatted value
 */
export const formatPhoneInput = (phone) => {
  if (!phone) return '';
  
  let value = phone.replace(/[^\d+\s]/g, '');
  
  if (/^\d/.test(value) && !value.startsWith('+')) {
    if (value.length >= 3) {
      return formatSlovakPhone(value);
    }
  }
  
  return value;
};

/**
 * Validate Slovak/Czech phone number format
 * @param {string} phone - Phone number to validate
 * @returns {boolean} - True if valid
 */
export const isValidSlovakPhone = (phone) => {
  if (!phone) return false;
  
  const cleaned = phone.replace(/[^\d+]/g, '');
  
  if (!cleaned.startsWith('+421') && !cleaned.startsWith('+420') && !cleaned.startsWith('0') && !cleaned.startsWith('00421') && !cleaned.startsWith('00420')) {
    return false;
  }
  
  let numberPart = cleaned;
  if (numberPart.startsWith('+421')) {
    numberPart = numberPart.substring(4);
  } else if (numberPart.startsWith('+420')) {
    numberPart = numberPart.substring(4);
  } else if (numberPart.startsWith('00421')) {
    numberPart = numberPart.substring(5);
  } else if (numberPart.startsWith('00420')) {
    numberPart = numberPart.substring(5);
  } else if (numberPart.startsWith('0')) {
    numberPart = numberPart.substring(1);
  }
  
  return numberPart.length === 9 && /^\d+$/.test(numberPart);
};
